<template>
  <div class="productView">
    <div class="productView">
        <img class="image" src="./indexImg/titleA.png" alt="">
    </div>
    <div class="caption">
        <img class="image" src="./indexImg/titlePc.png" alt="">
    </div>
    <div class="productList">
      <!-- <div class="productItem" v-for="item in productLists" :key="item.id">
        <div  class="productItemTitle"><img class="image" :src="item.image" alt=""></div>
        <span class="productItemVer">{{item.ver}}</span>
        <p class="productItemName">{{item.name}}</p>
        <p class="productItemBe">{{item.Be}}</p>
        <van-button round type="info" :to="item.push"> 点击下载 </van-button>
      </div> -->
      <div class="productItem" v-for="item in $store.state.productList" :key="item.ID">
        <div  class="productItemTitle">
          <!-- <img class="image" :src="item.TitlePic" alt=""> -->
          <el-image  :src="item.TitlePic" class="image" >
              <div slot="error" class="image-slot">
                  <img class="image" src="./indexImg/itemC.png" alt="">
              </div>
          </el-image>
        </div>
        <!-- <span class="productItemVer">{{item.ID}}</span> -->
        <p class="productItemName">{{item.Title}}</p>
        <p class="productItemBe">{{item.Info}}</p>
        <a href='javascript:;'>
          <!-- <van-button round type="info"  @click="open(item.ID)"> 查看详情 </van-button> -->
          <button class="onBtn" @click="open(item.ID)">查看详情</button>
        </a>

      </div>
    </div>
  </div>
</template>

<script>
import { getProductDown } from '@/api/product'
// 引入根路径
import request from '@/utils/request'
export default {
  name: 'productView',
  data () {
    return {
      productDown: []
    }
  },
  created () {
    this.getProductDown({ PageSize: 100, PageIndex: 1 })
  },
  methods: {
    async getProductDown (data) {
      const res = await getProductDown(data)
      if (res.Msg === '获取成功') {
        this.productDown = res.Data
        this.productDown.forEach(item => {
          item.Path = request.defaults.baseURL + item.Path
        })
      }
    },
    open (id) {
      // this.$toast('页面更新中。。。')
      // this.$router.push({ path: `/productItem/${id}` })
      this.$router.push({ path: `/productItemShow/${id}` })
      // this.$router.push({ path: `/productItem/${id}/${name}` })
    }
  }

}
</script>

<style lang="scss" scoped>
$md:72/192*2;
.caption{
    width: 250px/$md;
    height: 107px/$md;
    margin: 50px/$md auto;
}
.image{
    width:100%;
    height: 100%;
}
.productList{
  margin: 0 auto;
  width: 690px/$md;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .productItem{
    width: 330px/$md;
    height: 480px/$md;
    background: #FFFFFF;
    box-shadow: 0px/$md 0px/$md 30px/$md rgba(204,204,223,0.3);
    padding: 36px/$md 48px/$md;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    margin-bottom: 40px/$md;
    .productItemTitle {
      width: 70px/$md;
    }
    .productItemVer{
      height: 26px/$md;
      font-size: 20px/$md;
      margin: 6px/$md 0;
      color: #9FA4AF;}
    .productItemName{
      height: 35px/$md;
      font-size: 26px/$md;
      line-height: 35px/$md;
      color: #4F4F6F;
      margin-bottom: 20px/$md;
      text-align: center;
    }
    .productItemBe{
      height: 177px/$md;
      font-size: 24px/$md;
      font-family: MicrosoftYaHei;
      line-height: 36px/$md;
      color: #6D7DA0;
      text-align:center;
      margin-bottom: 30px/$md;
      overflow: hidden;
    }
    .onBtn{
      border: none;
      background-color: transparent;
      outline: none;
      width: 168px/$md;
      height: 50px/$md;
      background: #2380E1;
      box-shadow: 0px 0px 21px/$md rgba(204,204,223,0.5);
      border-radius: 25px/$md;
      color: #fff;
    }
  }
}
</style>
